import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import {
  Modal, Form, Button, message, Spin,
} from 'antd';
import DocConstant from './validate';
import AppApply from './AppApply';
import util from '../../../util/index';
import './style/app.less';

const {
  getEcId,
} = util;
const createForm = Form.create;
const {
  checkLicense,
} = DocConstant;
const store = ['modeListStore', 'initStore', 'homeStore'];
@inject(...store)
@observer
class App extends React.Component {

  static defaultProps = {
    prefixCls: "app-apply-modal",
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible || false,
    }
  }
  componentWillReceiveProps(nextProps) {
    const { visible } = this.props;
    if (nextProps.visible !== visible) {
      this.setState({ visible: nextProps.visible });
    }
  }
  onCancel = () => {
    const { onChange, modeListStore: { setMobxState }, form } = this.props;
    this.setState({ visible: false }, () => {
      typeof onChange === 'function' && onChange(false);
      form.resetFields();
      setMobxState({ isApply: false, tz: false, buyAppResult: {} });
    });
  }
  onSubmit = () => {
    const { form } = this.props;
    const me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    form.validateFields((errors, values) => {
      if (!errors) {
        me.com === "" ? this.doSubmitIntent(values) : this.handleOk(values);
      }
    });
  }
  doSubmitIntent = (values = {}) => {
    const { initStore: { doRegister }, modeListStore: { appDetail } } = this.props;
    const data = toJS(appDetail).app || {};
    const params = {
      ...values,
      mail: values.mail || '',
      mobile: values.mobile || '',
      type: 1,
      s_number: data.s_number,
      s_name: data.s_name,
    }
    doRegister(params).then(() => {
      this.onCancel();
    });
  }
  handleOk = () => {
    const { form, modeListStore: {
      buyApp, setMobxState, setDownLoad, appDetail,
    } } = this.props;
    const data = toJS(appDetail).app || {};
    const { getFieldsValue, getFieldValue } = form;
    const clientTypeTemp = getFieldValue('clientType');
    if ((clientTypeTemp && clientTypeTemp !== '2') && (data.s_fb && data.s_fb !== "1")) {
      const license = form.getFieldValue("license");
      if (!checkLicense(license)) {
        message.error("标识码必须由32位的英文字母或数字组成。");
        return;
      }
    }
    const params = {
      ...getFieldsValue(),
      orderType: data.s_fb,
      s_id: data.s_id,
      sw_id: data.sw_id,
      // c_id: getEcId(),
    };
    buyApp(params).then((v) => {
      if (clientTypeTemp && clientTypeTemp === '2') {
        setMobxState({ tz: false });
        setDownLoad(v.tmsl.TM_id);
      } else {
        setMobxState({ tz: true });
      }
    });
  }

  goOrder = () => {
    const { homeStore: { type }, goOrder } = this.props;
    typeof goOrder === 'function' ? goOrder() : window.open(`${window.server}/manager#/app/order?id=${toJS(type).id}`, '_blank');
  }

  render() {
    const { visible } = this.state;
    const { prefixCls, modeListStore: { tz, isApply, formLoading }, homeStore: { type }, } = this.props;
    return (
      <Modal
        title={(<div>申请应用<span style={{ fontSize: 12, color: '#f00' }}>{toJS(type).id === 'mode' && '(建模应用仅提供模板)'}</span></div>)}
        className={prefixCls}
        visible={visible}
        onCancel={this.onCancel}
        maskClosable={false}
        width={600}
        bodyStyle={{ minHeight: 400 }}
        footer={[
          <Button key="go" type="ghost" style={{ display: tz ? 'inline-block' : 'none' }} onClick={this.goOrder}>跳至我的订单</Button>,
          <Button key="submit" type="primary" onClick={this.onSubmit} disabled={isApply}>提交</Button>,
          <Button key="cancel" onClick={this.onCancel}>返回</Button>
        ]}
      >
        <Spin spinning={formLoading}>
          <AppApply {...this.props} />
        </Spin>
      </Modal >
    )
  }
}

App = createForm({
  onValuesChange: (props, changed, allValues) => {
    const { onFormChange } = props;
    typeof onFormChange === 'function' && onFormChange(changed, allValues);
  }
})(App);
export default App;


// WEBPACK FOOTER //
// ./src/components/util/appApply/index.js